// ./effects/auth.effects.ts
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators/tap';

import * as securityActions from '../store/actions';
import { SecurityServerService } from './SecurityServerService'

@Injectable()
export class SecurityServerServiceEffects {
  @Effect({ dispatch: false })
  logout$: Observable<Action> = this.actions$.pipe(
    ofType(securityActions.LOGOUT),
    tap( a => this.securityServerService.logout())
  );

  @Effect({ dispatch: false })
  changePassword$: Observable<Action> = this.actions$.pipe(
    ofType(securityActions.CHANGE_PASSWORD),
    tap(a => this.securityServerService.changePassword())
  );

  constructor(
    private securityServerService: SecurityServerService,
    private actions$: Actions
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/security/services/securityServerService.effects.ts